export const {
  REACT_APP_BASE_URL: BASE_URL,
  REACT_APP_DOMAIN,
  REACT_APP_CLIENT_ID,
  REACT_APP_AUDIENCE,
} = process.env;
